<div class="informe-dialog" [ngClass]="{'dark-theme': isDark}">

  <!-- ── Header ── -->
  <div class="informe-header">
    <h2 class="informe-title">
      <mat-icon>description</mat-icon>
      Generar Informe
    </h2>
    <button mat-icon-button (click)="dialogRef.close()" class="close-button" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ── Content ── -->
  <div class="informe-content">

    <!-- Left: form -->
    <div class="informe-col">
      <div class="section-header">
        <mat-icon class="small-icon">info</mat-icon>
        Información Adicional
      </div>

      <div class="form-stack">
        <div class="form-row">
          <label class="field-label">Nombre Cliente</label>
          <input type="text" class="informe-input" [(ngModel)]="nombre" placeholder="Nombre del cliente..." />
        </div>
        <div class="form-row">
          <label class="field-label">Descripción</label>
          <textarea class="informe-input informe-textarea" [(ngModel)]="descripcion" rows="4"
                    placeholder="Descripción del informe..."></textarea>
        </div>
      </div>

      <div class="col-action">
        <button mat-flat-button class="ccorbit pdf-btn" [disabled]="!dataCompleta" (click)="downloadPDF()">
          <mat-icon>picture_as_pdf</mat-icon>
          Descargar PDF
        </button>
      </div>
    </div>

    <!-- Divider -->
    <div class="informe-divider"></div>

    <!-- Right: model selection -->
    <div class="informe-col">
      <div class="section-header">
        <mat-icon class="small-icon">checklist</mat-icon>
        Seleccionar Modelos
      </div>

      <div class="params-table-wrapper">
        <cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
          #viewportValLat id="viewportValLat" class="model-scroll-viewport">
          <table cdk-table [dataSource]="listModelo" class="informe-table">

            <ng-container cdkColumnDef="nombre">
              <th cdk-header-cell *cdkHeaderCellDef>Modelo</th>
              <td cdk-cell *cdkCellDef="let element">{{ element.nombre }}</td>
            </ng-container>

            <ng-container cdkColumnDef="checkbox">
              <th cdk-header-cell *cdkHeaderCellDef></th>
              <td cdk-cell *cdkCellDef="let row">
                <mat-checkbox [disabled]="isLoading"
                              (change)="onRowCheckboxChange(row)"
                              [checked]="isIdSelected(row.idcartera)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container cdkColumnDef="eliminar">
              <th cdk-header-cell *cdkHeaderCellDef>Eliminar</th>
              <td cdk-cell *cdkCellDef="let element">
                <button class="delete-row-btn" (click)="eliminarCartera(element)" title="Eliminar">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

  </div>

  <!-- Spinner overlay -->
  <div class="spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

</div>

<!-- ── PDF content (hidden, used for PDF generation — do NOT modify) ── -->
<div id="contenedor-pdf">
  <div id="htmlData1" style="padding-left: 30px; padding-right: 30px;">
    <div class="row mt-2">
      <div class="col-6">
        <table class="custom-table mt-3">
          <tbody>
            <tr>
              <th scope="row" class="sticky-header">Nombre Cliente</th>
              <td>{{nombre}}</td>
            </tr>
            <tr>
              <th scope="row" class="sticky-header">Descripcion</th>
              <td>{{descripcion}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <img src="assets/logos/nectum.png" alt="" srcset="">
      </div>
    </div>
    <div class="row mt-2">
      <h5 class="sticky-header text-center">Condiciones de Entrada</h5>
      <table mat-table [dataSource]="modeloActualizado" class="mat-elevation-z8 custom-table">
        <ng-container matColumnDef="cartera">
          <th *matHeaderCellDef class="sticky-header">Nombre Modelo</th>
          <td *matCellDef="let element">{{element.cartera}}</td>
        </ng-container>
        <ng-container matColumnDef="fechaInicio">
          <th *matHeaderCellDef class="sticky-header">Fecha Inicio</th>
          <td *matCellDef="let element">{{element.fechaInicio}}</td>
        </ng-container>
        <ng-container matColumnDef="nombreMercado">
          <th *matHeaderCellDef class="sticky-header">Mercado</th>
          <td *matCellDef="let element">{{element.nombreMercado}}</td>
        </ng-container>
        <ng-container matColumnDef="nombrePeriodo">
          <th *matHeaderCellDef class="sticky-header">Frecuencia</th>
          <td *matCellDef="let element">{{element.nombrePeriodo}}</td>
        </ng-container>
        <ng-container matColumnDef="bajista">
          <th *matHeaderCellDef class="sticky-header">Alcista</th>
          <td *matCellDef="let element">{{element.bajista}}</td>
        </ng-container>
        <ng-container matColumnDef="condicion">
          <th *matHeaderCellDef class="sticky-header">Condicion</th>
          <td *matCellDef="let element">{{element.condicion}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsModelo"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsModelo;"></tr>
      </table>
    </div>
    <div class="row mt-2 mb-4">
      <div class="col-6">
        <h5 class="sticky-header text-center">Gestion Cuenta</h5>
        <table class="custom-table" *ngIf="optimaWallet">
          <tbody>
            <tr><th scope="row">Capital Inicial</th><td>{{optimaWallet.capitalinicial}}</td></tr>
            <tr><th scope="row">Valor Liquidativo Neto</th><td>{{optimaWallet.valorLiquidativo}}</td></tr>
            <tr><th scope="row">Efectivo</th><td>{{optimaWallet.efectivo}}</td></tr>
            <tr><th scope="row">Tipo Cuenta</th><td>{{optimaWallet.tipocuenta}}</td></tr>
            <tr><th scope="row">Apalancamiento</th><td>{{optimaWallet.apalancamiento}}</td></tr>
            <tr><th scope="row">Margen Requerido %</th><td>{{optimaWallet.margenRequeridoPor}}</td></tr>
            <tr><th scope="row">Control Margin Call</th><td>{{optimaWallet.controlMarginCall}}</td></tr>
            <tr><th scope="row">Nivel Margin Call</th><td>Verificar</td></tr>
            <tr><th scope="row">Margen Total</th><td>{{optimaWallet.margen}}</td></tr>
            <tr><th scope="row">Fondos Disponibles</th><td>{{optimaWallet.fondosDisponibles}}</td></tr>
            <tr><th scope="row">Poder Adquisitivo</th><td>{{optimaWallet.poderCompra}}</td></tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <h5 class="sticky-header text-center">Configuracion Cuenta</h5>
        <table class="custom-table" *ngIf="optimaWallet">
          <tbody>
            <tr><th scope="row">Riesgo Maximo %</th><td>{{optimaWallet.riesgomaximo}}</td></tr>
            <tr><th scope="row">Tipo Riesgo</th><td>{{optimaWallet.tiporiesgo}}</td></tr>
            <tr><th scope="row">Valor Riesgo</th><td>{{optimaWallet.riesgo}}</td></tr>
            <tr><th scope="row">Comision 2/2</th><td>{{optimaWallet.comisionbroker}}</td></tr>
            <tr><th scope="row">Gasto Gestion %</th><td>{{optimaWallet.gastosGestionPor}}</td></tr>
            <tr><th scope="row">Gasto Prestamo %</th><td>{{optimaWallet.gastosPrestamoPor}}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-6">
        <h5 class="sticky-header">Riesgo</h5>
        <table cdk-table [dataSource]="riesgo" class="custom-table">
          <ng-container cdkColumnDef="nombre">
            <th cdk-header-cell *cdkHeaderCellDef class="etiquetas">Nombre</th>
            <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
          </ng-container>
          <ng-container cdkColumnDef="dato">
            <th cdk-header-cell *cdkHeaderCellDef class="etiquetas">Dato</th>
            <td cdk-cell *cdkCellDef="let element" style="width:30%">{{element.dato}}</td>
          </ng-container>
          <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRR" hidden></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRR;"></tr>
        </table>
      </div>
      <div class="col-6">
        <h5 class="sticky-header">Rendimientos</h5>
        <table cdk-table [dataSource]="rentabilidad" class="custom-table">
          <ng-container cdkColumnDef="nombre">
            <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Nombre</th>
            <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
          </ng-container>
          <ng-container cdkColumnDef="dato">
            <th cdk-header-cell *cdkHeaderCellDef class="etiquetas">Dato</th>
            <td cdk-cell *cdkCellDef="let element" style="width:30%">{{element.dato}}</td>
          </ng-container>
          <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRR" hidden></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRR;"></tr>
        </table>
      </div>
    </div>
  </div>
  <div id="htmlData2" style="padding-left: 30px; padding-right: 30px;">
    <div class="row mt-2 mb-2">
      <table cdk-table [dataSource]="rendAnual" class="custom-table">
        <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRend; sticky: true" class="sticky-header custom-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRend;"></tr>
        <ng-container *ngFor="let tablecol of tableColumnsRend">
          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">{{tablecol.name}}</th>
            <td cdk-cell *cdkCellDef="let item">
              <ng-container *ngIf="tablecol.isString">{{item[tablecol.id]}}</ng-container>
              <ng-container *ngIf="tablecol.isNumber">{{item[tablecol.id] | number:'1.2-2'}}</ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </div>
    <div class="row mt-2">
      <div id="containerPDF"></div>
    </div>
  </div>
</div>
